const HealthFeaturesSection = () => {
  return (
    <section className="py-20" data-cy="health-features-section">
      <div className="mb-10 text-center text-6xl font-bold">
        As you evolve, so does Oura Membership
      </div>
      <div className="grid grid-cols-2 px-20">
        <div className="h-96 rounded-2xl bg-sandstone-500" />
        <div className="flex flex-col gap-4 p-20">
          <div className="flex flex-row gap-20">
            <div className="h-12 w-full rounded-full border border-sandstone-500" />
            <div className="h-12 w-full rounded-full border border-sandstone-500" />
          </div>
          <div className="flex flex-row gap-20">
            <div className="h-12 w-full rounded-full border border-sandstone-500" />
            <div className="h-12 w-full rounded-full border border-sandstone-500" />
          </div>
          <div className="flex flex-row gap-20">
            <div className="h-12 w-full rounded-full border border-sandstone-500" />
            <div className="h-12 w-full rounded-full border border-sandstone-500" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthFeaturesSection;
